// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__2QDIk","title":"AfterImages45_title__Fe6wO","images":"AfterImages45_images__12kWr"};